import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import LatestArticles from "./components/LatestArticles";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 4);
  const latestArticles = articles.slice(0, 9);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料社区",
    url: "https://heiliaoshequ.cn",
    description: "黑料社区是一个专注于热点事件追踪与深度分析的资讯平台，为您提供最新、最全面的爆料资讯和社会热点解读。",
    logo: "https://heiliaoshequ.cn/logo.png",
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑料社区",
    url: "https://heiliaoshequ.cn",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://heiliaoshequ.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="黑料社区 - 最新爆料资讯与深度分析平台"
        description="黑料社区是一个专注于热点事件追踪与深度分析的资讯平台，提供最新社会热点、娱乐八卦、科技数码、财经内幕等全方位爆料资讯，为您还原事实真相。"
        keywords="黑料社区,爆料资讯,热点追踪,深度揭秘,娱乐八卦,社会万象,科技数码,财经内幕,深度分析"
        canonicalUrl="https://heiliaoshequ.cn"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20news%20and%20media%20website%20homepage%2C%20modern%20clean%20design%2C%20journalism%20theme%2C%20red%20and%20white%20color%20scheme%2C%20professional%20layout%2C%20news%20portal%20header%20image&width=1200&height=630&seq=home-og&orientation=landscape"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />

      <Navbar />
      <main>
        <HeroBanner hotArticles={hotArticles} />
        <CategoryNav categories={categories} />
        <FeaturedArticles articles={featuredArticles} />
        <LatestArticles articles={latestArticles} />
      </main>
      <Footer />
    </>
  );
}